<template>
  <div class="simple-modal">
    <PageShadow />
    <div class="simple-modal__modal">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import PageShadow from "@/components/PageShadow.vue";

export default {
  components: {
    PageShadow
  }
};
</script>

<style scoped lang="scss">
.simple-modal {
  &__modal {
    background: #fff;
    width: calc(100% - 48px);
    max-width: 524px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: $spacing-4;
    z-index: 5000;
    border-radius: 16px;
  }
}
</style>
